module.exports = __webpack_public_path__ + "img/mbank.5edb73c4.png";